import { render } from "./ComputerAided.vue?vue&type=template&id=06184e2c&scoped=true"
import script from "./ComputerAided.vue?vue&type=script&lang=js"
export * from "./ComputerAided.vue?vue&type=script&lang=js"

import "./ComputerAided.vue?vue&type=style&index=0&id=06184e2c&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06184e2c"]])

export default __exports__